/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './cholesterol.reducer';

export const CholesterolDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const cholesterolEntity = useAppSelector(state => state.cholesterol.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="cholesterolDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.cholesterol.detail.title">Cholesterol</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.cholesterol.id">Id</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.id}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.cholesterol.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.cursor}</dd>
          <dt>
            <span id="hdlreading">
              <Translate contentKey="tinyMedicRestApp.cholesterol.hdlreading">Hdlreading</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.hdlreading}</dd>
          <dt>
            <span id="ldlreading">
              <Translate contentKey="tinyMedicRestApp.cholesterol.ldlreading">Ldlreading</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.ldlreading}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.cholesterol.active">Active</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.cholesterol.created">Created</Translate>
            </span>
          </dt>
          <dd>
            {cholesterolEntity.created ? <TextFormat value={cholesterolEntity.created} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.cholesterol.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.cholesterol.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.timestampentry}</dd>
          <dt>
            <span id="totalReading">
              <Translate contentKey="tinyMedicRestApp.cholesterol.totalReading">Total Reading</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.totalReading}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.cholesterol.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{cholesterolEntity.lastupdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.cholesterol.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{cholesterolEntity.glucoUser ? cholesterolEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/cholesterol" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/cholesterol/${cholesterolEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CholesterolDetail;
